import { FetchError, RequiredError, ResponseError } from "../../server/lads-api/clients/lcc-openapi";

export class APiError extends Error {
  status: number = 0;
  statusText: string = "Unknown Error";
  body?: object;

  constructor(message: string = "Unknown error", statusCode: number = 500, body?: object ) {
    super(message);
    this.status = statusCode;
    this.statusText = message;
    this.body = body;
  }

  static fromError(error: unknown) : APiError {
    if (error instanceof ResponseError) {
      const err = new APiError(error.response.statusText, error.response.status, error.response.clone().json());
      err.cause = error;
      return err;
    }
    if (error instanceof RequiredError) {
      return new APiError(error.message || `Missing required field: ${error.field}`, 400);
    }
    if (error instanceof FetchError) {
      const err = new APiError(error.message, 500);
      err.cause = error.cause;
      return err;
    }
    return new APiError()
  }
}
